/**
 * @author      xinzhe.chai@zumper.com (Xinzhe Chai)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { Theme, css } from '@emotion/react'
import { PAD_MAPPER, focusRing } from '@zcode-ui/themes'

export const button = ({ colors, spacing, typography, name }: Theme) => css`
  font-weight: ${typography.fontWeightMedium};
  font-family: ${typography.bodyFontFamily};
  letter-spacing: -0.2px;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;

  border: 0;
  border-radius: ${name === PAD_MAPPER ? '3px' : '6px'};
  cursor: pointer;

  transition: all 100ms ease-in;

  user-select: none;

  label: button;

  :disabled {
    cursor: default;
    opacity: 0.7;
  }

  &:focus {
    ${focusRing({ colors, spacing, typography })}
  }
`

export const primaryButton = ({ colors }: Theme) => css`
  color: #fff;

  background-color: ${colors.primaryButton};

  label: primarybutton;

  :hover:not(:disabled) {
    background-color: ${colors.primaryButtonDark};
  }
`

export const spacesButton = ({ spacing, colors }: Theme) => css`
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${colors.primaryDark};
  }
`
